export default "__VITE_PUBLIC_ASSET__fc7fd66d__"